import React, { useState, useEffect } from "react";
import { CustomPostAPI } from "../../Utils/APIConnector";
import { RedirectedPage } from "./RedirectedPage";
import "../../../css/common.css";
import { useNavigate } from "react-router-dom";
import HelmetMetaTag from "../../Utils/HelmetMetaTag/HelmetMetaTag";
import Loader from "../../Utils/Loader";

export function LatestLoginForm() {
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordType, setPasswordType] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("User_Authenticated");
  useEffect(() => {
    if (isLoggedIn) {
      navigate("/admin-stats");
    } else {
      navigate("/admin-login");
    }
  }, [isLoggedIn]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setLoader(true);
    var raw = JSON.stringify({
      name: name,
      password: password,
    });

    try {
      const result = JSON.parse(
        await CustomPostAPI("/Auth/AdminStatsLogin", raw)
      );
      if (result.status === "success") {
        setLoader(false);
        localStorage.setItem("User_Authenticated", true);
        navigate("/admin-stats");
      } else {
        setErrorMessage(result.message);
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
      setLoader(false)
    } finally {
      setLoader(false);
    }
  };

  return (
    <React.Fragment>
      <HelmetMetaTag
        titleName="CricBuddy | Admin Stats"
        desc=""
        canonical={window.location.href}
        ogtitle="CricBuddy | Admin Stats"
        ogdesc=""
        ogtype="website"
        ogurl={window.location.href}
        ogimg="https://cricbuddy.in/logo192.png"
      />
      <section className="container ">
        <div
          className="rounded-2 shadow-sm p-3 p-md-5 mt-4 mx-md-5"
          style={{ border: "1px solid #0000000D" }}
        >
          <h2 className="heading-color mb-4 h3">Admin Login</h2>
          <form
            className="d-flex flex-column gap-4"
            onSubmit={(event) => handleSubmit(event)}
          >
            <div className="d-flex flex-column">
              <label className="mb-2" style={{ color: "#9A9A9A" }}>
                User Name
              </label>
              <input
                autoComplete="false"
                type="text"
                value={name}
                className="border-0 shadow-sm px-3 py-2 py-md-3 rounded"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="d-flex flex-column">
              <label className="mb-2" style={{ color: "#9A9A9A" }}>
                Password
              </label>
              <div className="d-flex gap-0 w-100 justify-content-between shadow-sm rounded">
                <input
                  autoComplete="false"
                  type={passwordType ? "text" : "password"}
                  value={password}
                  className="border-0 px-3 py-2 py-md-3 w-100 rounded-start"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <img
                  src="/images/AdminStatsEye.svg"
                  alt=""
                  className="px-3 rounded-end cursor-pointer"
                  onClick={() => setPasswordType(!passwordType)}
                />
              </div>
            </div>
            {errorMessage && <span className="text-danger text-center">{errorMessage}</span>}
            <button
              type="submit"
              className="py-2 py-md-3 mt-3 rounded border-0 h5 text-white"
              style={{ backgroundColor: "#E7666A" }}
            >
              {loader ? (
                <div class="spinner-border text-light" role="status" />
              ) : (
                "Login"
              )}
            </button>
          </form>
        </div>
      </section>
    </React.Fragment>
  );
}
